import React from 'react';
import { usePageNavigationSync } from '../../hooks/usePageNavigationSync';

/**
 * Component to handle page navigation sync
 * Must be rendered inside DataSyncProvider
 */
const NavigationSyncManager: React.FC = () => {
  usePageNavigationSync();
  return null; // This component only provides side effects
};

export default NavigationSyncManager;